var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRbottomExperience(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 398,
    viewBox: "0 0 183 398",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M302.31 267.139C288.274 304.359 246.284 332.15 211.615 351.652C178.065 370.524 147.582 354.372 109.655 347.791C68.6294 340.673 26.7302 349.972 10.0206 311.834C-5.98498 275.302 63.0558 264.528 75.9955 226.801C87.1638 194.24 53.7944 133.203 79.2405 110.019C111.328 80.7843 165.637 26.4312 208.682 32.0368C254.89 38.0544 235.765 117.358 257.317 158.673C277.885 198.101 318.002 225.53 302.31 267.139Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M288.381 265.533C275.728 299.087 237.875 324.142 206.621 341.723C176.376 358.737 148.895 344.176 114.705 338.243C77.7211 331.826 39.9495 340.21 24.8863 305.828C10.4578 272.894 72.6971 263.181 84.3624 229.17C94.4307 199.815 64.349 144.79 87.2885 123.889C116.215 97.5335 165.175 48.5332 203.978 53.5864C245.635 59.011 228.393 130.504 247.822 167.75C266.363 203.295 302.528 228.022 288.381 265.533Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M279.231 264.157C267.533 295.177 232.543 318.341 203.652 334.596C175.695 350.326 150.294 336.866 118.691 331.383C84.5052 325.451 49.5908 333.204 35.6686 301.419C22.3329 270.972 79.8639 261.99 90.6479 230.547C99.9556 203.408 72.1519 152.539 93.3567 133.216C120.096 108.849 165.353 63.5475 201.221 68.2176C239.726 73.231 223.786 139.326 241.743 173.759C258.881 206.618 292.308 229.477 279.231 264.157Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M267.389 260.948C257.393 287.466 227.505 307.272 202.829 321.172C178.949 334.623 157.259 323.122 130.269 318.442C101.075 313.379 71.2556 320.012 59.3719 292.846C47.9887 266.825 97.1238 259.136 106.34 232.257C114.294 209.058 90.5591 165.583 108.672 149.062C131.513 128.229 170.173 89.498 200.805 93.4828C233.688 97.7605 220.062 154.259 235.391 183.687C250.021 211.771 278.564 231.303 267.389 260.948Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.001 262.589C248.893 286.741 221.645 304.775 199.148 317.43C177.376 329.676 157.595 319.195 132.983 314.924C106.361 310.305 79.1719 316.339 68.3287 291.591C57.9422 267.885 102.744 260.894 111.141 236.413C118.388 215.283 96.7338 175.676 113.246 160.632C134.068 141.661 169.311 106.391 197.243 110.029C227.229 113.934 214.818 165.395 228.804 192.204C242.151 217.789 268.184 235.588 258.001 262.589Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.249 261.056C238.308 282.112 214.545 297.831 194.925 308.862C175.939 319.537 158.686 310.397 137.221 306.672C114.002 302.642 90.2901 307.901 80.8311 286.324C71.7706 265.656 110.843 259.565 118.164 238.223C124.483 219.802 105.594 185.27 119.994 172.155C138.152 155.618 168.885 124.873 193.246 128.046C219.398 131.453 208.579 176.317 220.779 199.691C232.422 221.998 255.127 237.517 246.249 261.056Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.167 261.928C231.925 281.125 210.254 295.457 192.361 305.513C175.046 315.245 159.309 306.91 139.732 303.512C118.556 299.836 96.93 304.629 88.3016 284.955C80.0367 266.11 115.672 260.559 122.348 241.1C128.109 224.305 110.88 192.817 124.012 180.861C140.571 165.784 168.599 137.753 190.817 140.648C214.669 143.756 204.805 184.661 215.933 205.974C226.553 226.314 247.262 240.466 239.167 261.928Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.213 261.078C212.117 274.59 196.869 284.677 184.279 291.756C172.096 298.606 161.025 292.741 147.251 290.351C132.351 287.765 117.135 291.14 111.066 277.294C105.252 264.031 130.324 260.122 135.022 246.426C139.077 234.606 126.956 212.446 136.197 204.03C147.849 193.418 167.57 173.688 183.203 175.725C199.984 177.911 202.59 200.332 210.418 215.331C217.889 229.646 222.911 245.973 217.213 261.078Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.388 259.96C203.295 270.824 191.069 278.942 180.974 284.639C171.206 290.153 161.415 288.658 151.3 283.533C148.497 281.152 147.971 281.019 145.646 275.691C140.996 265.035 137.755 259.247 141.529 248.236C144.786 238.732 135.086 220.929 142.497 214.159C151.842 205.622 167.659 189.751 180.186 191.377C193.633 193.124 195.707 211.143 201.971 223.195C207.949 234.695 211.963 247.816 207.388 259.96Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M198.039 255.285C195.02 263.327 186.044 269.353 178.636 273.585C171.467 277.68 164.294 276.592 156.89 272.82C154.84 271.064 154.455 270.967 152.76 267.031C149.371 259.158 147.006 254.884 149.792 246.733C152.196 239.699 145.119 226.549 150.563 221.529C157.427 215.199 169.048 203.432 178.226 204.613C188.079 205.88 189.566 219.203 194.136 228.104C198.496 236.599 201.414 246.295 198.039 255.285Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M189.379 250.469C187.583 255.261 182.258 258.856 177.864 261.382C173.611 263.827 169.36 263.184 164.973 260.943C163.76 259.899 163.531 259.841 162.53 257.498C160.527 252.812 157.267 249.549 157.104 246.814C156.942 244.079 154.373 243.788 161.261 230.401C165.335 226.626 172.233 219.61 177.672 220.306C183.512 221.053 184.384 228.987 187.086 234.285C189.664 239.34 191.387 245.113 189.379 250.469Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.95 248.779C183.646 252.259 179.785 254.871 176.598 256.707C173.515 258.483 169.964 260.127 167.254 256.392C166.375 255.634 166.209 255.592 165.484 253.891C164.033 250.489 161.671 248.121 161.554 246.135C161.438 244.15 159.698 240.062 164.573 234.216C167.527 231.474 172.53 226.377 176.473 226.881C180.706 227.422 181.335 233.182 183.292 237.028C185.16 240.698 186.407 244.889 184.95 248.779Z",
    fill: "#C4C4C4",
    fillOpacity: 0.02,
    stroke: "#01316E",
    strokeOpacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRbottomExperience);
export default __webpack_public_path__ + "static/media/Rbottom-Experience.07196997d965a353a7dff86f77e561c5.svg";
export { ForwardRef as ReactComponent };